<form [formGroup]="formGroup" class="fga">
  @if (pageTitle) {
    <div class="fga-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="fga-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "radiogroup") {
      <div class="fga-row">
        <div class="fga-q">
          <div class="fga-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="fga-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="fga-group">
          @for (choice of element.choices; track choice.value) {
            <label class="fga-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span class="fga-option-text">{{
                choice.text
              }}</span>
            </label>
          }
        </div>
      </div>
    }
    @if (isTotalScoreElement(element)) {
      <div class="fga-total">
        <div class="fga-total-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="fga-total-score">
          {{ getScoreDisplay() }} / {{ maxScore }}
        </div>
      </div>
    }
  }
</form>
